import { useEffect, useRef } from 'react';
import { useRepo } from '../useStore.js';

export default function WritePane({ nav, go, space, doc, editing, analysis, newDoc }) {
  const repo = useRepo();
  const titleRef = useRef(null);
  const bodyRef = useRef(null);

  // A freshly created document should be ready to write in: the title when it
  // needs naming, the body when it arrives pre-titled (journal entries do).
  useEffect(() => {
    if (!doc || nav.focusTitle !== doc.id) return;
    (doc.title ? bodyRef.current : titleRef.current)?.focus();
    go({ focusTitle: null });
  }, [nav.focusTitle, doc?.id, doc?.title, go]);

  return (
    <div className="write-wrap">
      <div className="write-col">
        <div className="page">
          {doc ? (
            <>
              <input
                ref={titleRef}
                className="doc-title-input" aria-label="Title" placeholder="Untitled"
                value={doc.title}
                onChange={e => repo.patchDocument(doc.id, { title: e.target.value })}
              />
              {editing
                ? <div className="read-view" dangerouslySetInnerHTML={{ __html: analysis?.html ?? '' }} />
                : <textarea
                    ref={bodyRef}
                    className="doc-body" aria-label="Document text" spellCheck="false"
                    placeholder="Begin here. Markdown works: # heading, **bold**, *italic*, > quote."
                    value={doc.content}
                    onChange={e => repo.patchDocument(doc.id, { content: e.target.value })}
                  />}
            </>
          ) : (
            <div className="empty-doc">
              <p>{space?.id === 'journal' ? 'No entry open.' : 'No document open.'}</p>
              <button className="dashed" onClick={newDoc}>
                + {space?.id === 'journal' ? 'New entry' : 'New document'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
